export const inventoryLists_api = {
  url: 'inventoryLists',
  method: 'post',
  title: '库存列表',
}

export const export_api = {
  url: 'inventoryListsDownload',
  method: 'post',
  title: '库存列表导出',
}


// WEBPACK FOOTER //
// ./src/views/base/inventory/desc.js